import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Route, Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { InformationService } from '../../../services/information.service';
import { BuildingService } from '../../../services/building.service';
import { SharedService } from '../../../services/shared.service';
import { LocationMihSiteUnit } from '../../../viewmodel';
import { BuildingQuestionParam } from '../../../viewmodel';
import { Animations } from '../../common/animations';

@Component({
    selector: 'app-locationmihsiteunit',
  templateUrl: './locationmihsiteunit.component.html',
  providers: [InformationService, BuildingService],
  animations: [Animations.flyInOut]
})
export class LocationMihSiteUnitComponent implements OnInit {

    animate: string = 'active';
    title: string = 'Location of MIH Units';

    projectId: number = 0;
    buildingId: number = 0;
    //projBuildingId: number = 0;
    devProjectBuildingId: number = 0;
    siteProjectBuildingId: number = 0;
    trackingId: number = 0;
    entityId: number = 0;
    buildingAddress: string = '';
    pageError: any = [];
    pageSuccess: any = [];
    isEdit: boolean = false;
    submitted: boolean = false;
    questionType: number = 704;
    questionForm: FormGroup;
    model: LocationMihSiteUnit;
    editable: any = null;   //'disabled' or null for enable

    constructor(private router: Router
        , private frmBuilder: FormBuilder
        , private activeRoute: ActivatedRoute
        , private informationService: InformationService
        , private buildingService: BuildingService
        , private sharedService: SharedService) {

        this.model = new LocationMihSiteUnit();
        this.model.ProjectId = this.projectId; 
    }
    ngOnInit() {
    
        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null)
                this.projectId = this.model.ProjectId = ids.projectId;
        }
        else {
            if (this.model.ProjectId == 0 && this.projectId == 0)
            this.sharedService.navigateHome();
        }
                  
        let bqp = this.sharedService.getJsonData('BuildingQuestionParam');
        if (bqp != null) {
            this.devProjectBuildingId = this.model.DevProjectBuildingId = bqp.devProjectBuildingId;
            this.siteProjectBuildingId = this.model.SiteProjectBuildingId = bqp.siteProjectBuildingId;
            this.buildingId = this.model.BuildingId = bqp.bldgId;
            if (!(bqp.buildingAddress == null || bqp.buildingAddress == ''))
                this.buildingAddress = '- ' + bqp.buildingAddress;
        }
        else {
            this.sharedService.navigateSummary();
        }
        if (this.siteProjectBuildingId == null || this.buildingId == null)
            this.sharedService.navigateSummary();

        this.questionForm = this.frmBuilder.group({
            location: ['', Validators.required]
        })

        this.informationService.GetProjectBuildingSiteLocation(this.devProjectBuildingId, this.siteProjectBuildingId)
            .subscribe(
            success => {
                if (!success.Success)
                    this.showError(success.StatusMessage);
                else {
                    if (success.Result != null) {
                        this.PopulateData(success.Result);
                        this.isEdit = success.Result.IsValid;                         
                    }

                    if (this.model.ProjectId == 0 && this.projectId == 0)
                        this.showError("Project ID not found!")
                    else if (this.model.ProjectId == 0)
                        this.model.ProjectId = this.projectId;
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage)
            })

    }

    save(button) {
        this.submitted = true;
        if (!this.questionForm.valid) {
            return false;
        }

        if(this.model.MihSiteLocation == null || this.model.MihSiteLocation == '')
            return false; 

        this.model.IsValid = true;
        this.informationService.SaveProjectBuildingSiteLocation(this.model)
            .subscribe(
            success => {
                if (!success.Success) {
                    this.showError(success.StatusMessage);
				}
                else {
                    if (button == 'NEXT') {
                        //this.setBuildingQuestionParam(success.Result);
                        this.router.navigate(["/buildings/taxcredit"]);
                    }
                    else if (button == 'LATER')
                        this.sharedService.navigateSummary();
                }
            },
            error => {
                if (error.status == 401)
                    this.router.navigateByUrl('/login?session=0');

                this.showError(error.ExceptionMessage);
            })
    }


    previous() {
        this.router.navigate(["/buildings/buildingtype"]);
    }

    home() {
        this.sharedService.navigateHome();
    }

    PopulateData(question) {
        if (question == null || question.length == 0) {
            this.model.MihSiteLocation = null;
            return false;
        }
        this.model.MihSiteLocation = question.MihSiteLocation; 
        if (question.Editable == false)
            this.editable = 'disable';
        else
            this.editable = null;         
    }

    setBuildingQuestionParam(building) {
        var BQP = new BuildingQuestionParam();
        BQP.devProjectBuildingId = building.DevProjectBuildingId;
        BQP.siteProjectBuildingId = building.SiteProjectBuildingId;
        BQP.bldgId = building.BuildingId;
        BQP.mood = 'A';
        this.sharedService.setJsonData('BuildingQuestionParam', BQP);
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

}
